export const APP_NAME = "Admin Panel";
export const APP_KEY = "admin-console";

// Redirect Paths
export const REDIRECT_URL_KEY = "redirect";
export const HOME_PATH = "/";
export const GHOST_ENTRY_PATH = "/login";

// Navigation Types
export type NavigationType = "root" | "group" | "collapse" | "item" | "divider";

export const COLORS = [
  "neutral",
  "primary",
  "secondary",
  "info",
  "success",
  "warning",
  "error",
] as const;

export type ColorType = (typeof COLORS)[number];

export const IS_ENCRYPTION_ENABLED = import.meta.env.MODE === 'prod' || import.meta.env.MODE === 'qa' || import.meta.env.MODE === 'uat';
console.log('IS_ENCRYPTION_ENABLED:', import.meta.env.MODE);

// Enable reCAPTCHA only in production
export const IS_RECAPTCHA_ENABLED = import.meta.env.MODE === 'prod' || import.meta.env.MODE === 'qa';
